// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel-article-related-media-files-item/carousel-article-related-media-files-item.component.scss
// module id = 186
// module chunks = 0